import {isInChat, isLama, isLamaLudo, isWeParty, isWyak} from "../dev";
import {isNil} from "lodash";

export const getResUrl = (path) => {
  return `https:${
    isLama ? "//cdn.wenext.love" : "//wayak-resource.wenext.media"
  }${path}`;
};

export function getLocationQueryString(key) {
  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export const getQueryParamFromLocation = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

export const getDefaultAvatar = () => {
  if (isWyak) {
    return require("@mono/ui/assets/common_default_avatar_ic_wyak.png");
  } else if (isWeParty) {
    return require("@mono/ui/assets/common_default_avatar_ic_weparty.png");
  } else if (isLamaLudo) {
    return require("@mono/ui/assets/common_default_avatar_ic_ludo.png");
  } else if (isInChat) {
    return require("@mono/ui/assets/common_default_avatar_ic_inchat.png");
  } else {
    return require("@mono/ui/assets/common_default_avatar_ic_lama.png");
  }
};

export function getAvatarUrl(userInfo) {
  if (isNil(userInfo)) {
    return getDefaultAvatar();
  }

  if (userInfo.avatarDynamicUrl !== undefined && userInfo.avatarDynamicUrl !== "") {
    return userInfo.avatarDynamicUrl;
  }

  if (userInfo.avatar !== undefined && userInfo.avatar !== "") {
    return userInfo.avatar;
  }

  if (isNil(userInfo.url) || userInfo.url === "") {
    return getDefaultAvatar();
  }

  return userInfo.url;
}

export function getUserId(userInfo) {
  if (isNil(userInfo)) {
    return 0;
  }

  if (!isNil(userInfo.goodIdInfo) && !isNil(userInfo.goodIdInfo.goodId)) {
    return userInfo.goodIdInfo.goodId;
  }

  if (!isNil(userInfo.sid)) {
    return userInfo.sid;
  }

  return 0;
}
